import React from 'react';
import { ActionIcon, Group, Text } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { useNavigate } from 'react-router';
import { useCurrentClientIfAvailable } from 'src/clients/context/CurrentClientProvider';
import { useFlags } from 'src/feature-flags/FlagsHook';

type Props = {
  title: string;
};

export function FormTitle({ title }: Props) {
  const navigate = useNavigate();
  const { client } = useCurrentClientIfAvailable();
  const { flagEnabledNewLayout } = useFlags();

  const backPath = flagEnabledNewLayout
    ? `/client/${client?.id}/financial-data/create`
    : `/client/${client?.id}/financial-data`;

  return (
    <Group>
      <ActionIcon variant="subtle" onClick={() => navigate(backPath)} data-testid="back-button">
        <IconArrowLeft color="black" />
      </ActionIcon>
      <Text size={'displayMd'} fw={600}>
        {title}
      </Text>
    </Group>
  );
}
